var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.156,
    height: 13.156,
    viewBox: "0 0 13.156 13.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Instagram",
    d: "M506.578,160c-1.786,0-2.01.008-2.712.04a4.827,4.827,0,0,0-1.6.306,3.363,3.363,0,0,0-1.924,1.924,4.826,4.826,0,0,0-.306,1.6c-.032.7-.04.926-.04,2.712s.008,2.01.04,2.712a4.826,4.826,0,0,0,.306,1.6,3.363,3.363,0,0,0,1.924,1.924,4.828,4.828,0,0,0,1.6.306c.7.032.926.04,2.712.04s2.01-.008,2.712-.04a4.829,4.829,0,0,0,1.6-.306,3.364,3.364,0,0,0,1.924-1.924,4.828,4.828,0,0,0,.306-1.6c.032-.7.04-.926.04-2.712s-.008-2.01-.04-2.712a4.828,4.828,0,0,0-.306-1.6,3.364,3.364,0,0,0-1.924-1.924,4.828,4.828,0,0,0-1.6-.306C508.588,160.008,508.364,160,506.578,160Zm0,1.185c1.756,0,1.964.007,2.658.038a3.64,3.64,0,0,1,1.221.226,2.178,2.178,0,0,1,1.248,1.248,3.639,3.639,0,0,1,.227,1.221c.032.694.038.9.038,2.658s-.007,1.964-.038,2.658a3.639,3.639,0,0,1-.227,1.221,2.178,2.178,0,0,1-1.248,1.248,3.64,3.64,0,0,1-1.221.226c-.694.032-.9.038-2.658.038s-1.965-.007-2.658-.038a3.64,3.64,0,0,1-1.221-.226,2.178,2.178,0,0,1-1.248-1.248,3.637,3.637,0,0,1-.227-1.221c-.032-.694-.038-.9-.038-2.658s.007-1.964.038-2.658a3.637,3.637,0,0,1,.227-1.221,2.178,2.178,0,0,1,1.248-1.248,3.64,3.64,0,0,1,1.221-.226C504.614,161.192,504.822,161.185,506.578,161.185Zm0,2.015a3.378,3.378,0,1,0,3.378,3.378A3.378,3.378,0,0,0,506.578,163.2Zm0,5.571a2.193,2.193,0,1,1,2.193-2.193A2.193,2.193,0,0,1,506.578,168.771Zm4.3-5.7a.789.789,0,1,1-.789-.789A.789.789,0,0,1,510.879,163.067Z",
    transform: "translate(-500 -160)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a6b43363.svg";
export { ForwardRef as ReactComponent };